import { render, staticRenderFns } from "./DashboardCardDepositAndWithdraw.vue?vue&type=template&id=3bb560de"
import script from "./DashboardCardDepositAndWithdraw.vue?vue&type=script&lang=js"
export * from "./DashboardCardDepositAndWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports